import { render, staticRenderFns } from "./ExchangeTransactionList.vue?vue&type=template&id=81c985a2&"
import script from "./ExchangeTransactionList.vue?vue&type=script&lang=js&"
export * from "./ExchangeTransactionList.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeTransactionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports